export default "__VITE_ASSET__D9JY$xo6__"